import React, { useState } from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: 'Funktioniert der Digital Key auch ohne Internet?',
    a: 'Ja, absolut. Dank Bluetooth Low Energy (BLE) Technologie können Sie Ihr Fahrzeug auch ohne Mobilfunknetz zuverlässig öffnen und starten. Die 4G-Funktionen sind zusätzlich für die Fernsteuerung verfügbar.'
  }, {
    q: 'Wie sicher ist das System?',
    a: 'Sicherheit hat höchste Priorität. Wir nutzen End-to-End-Verschlüsselung auf Bankenniveau und halten uns an strikte OEM-Sicherheitsstandards. Ihre Daten sind DSGVO-konform geschützt.'
  }, {
    q: 'Ist die Lösung für Flotten geeignet?',
    a: 'Ja, TIKA Mobility ist speziell für Flottenmanagement optimiert. Unser Dashboard bietet Funktionen wie Fahrerzuweisung, Nutzungsanalysen und zentrales Schlüsselmanagement für hunderte Fahrzeuge.'
  }, {
    q: 'Wie läuft die Installation ab?',
    a: 'Die Installation erfolgt durch zertifizierte Partner oder Techniker. Dank fahrzeugspezifischer Kabelsätze (T-Harness) müssen keine Originalkabel durchtrennt werden. Das System ist vollständig rückrüstbar.'
  }];
  return <section className="py-24 bg-[#0f0f16]" data-id="element-116">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl" data-id="element-117">
        <SectionHeading title="Häufig gestellte Fragen" align="center" className="mb-12" data-id="element-118" />

        <div className="space-y-4" data-id="element-119">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-800 rounded-lg bg-[#0a0a0f] overflow-hidden" data-id="element-120">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-121">
                <span className="font-medium text-white" data-id="element-122">{faq.q}</span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-cyan-400" data-id="element-123" /> : <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-124" />}
              </button>
              <AnimatePresence data-id="element-125">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden" data-id="element-126">
                    <div className="p-6 pt-0 text-gray-400 leading-relaxed border-t border-gray-800/50" data-id="element-127">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}